import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {ExpressionsGroupsEnum} from '../../editors/expressions/expressionGroupHelpers';
import {StyledDropdownGroupTitleWrapper} from '../../rules/ruleEditor/ruleEditorCommons';

/*
 * Types.
 */

interface ExpressionGroupTitleProps {
  id: ExpressionsGroupsEnum;
}

/*
 * Component.
 */

export const ExpressionGroupTitle: FC<ExpressionGroupTitleProps> = (props) => {
  const {id} = props;

  return <StyledDropdownGroupTitleWrapper>{getTitle(id)}</StyledDropdownGroupTitleWrapper>;
};

/*
 * Helpers.
 */

const getTitle = (id: ExpressionsGroupsEnum) => {
  switch (id) {
    case ExpressionsGroupsEnum.CONVERSATION:
      return <Trans id="editor-expression-group-title-conversation">Extract conversation property</Trans>;

    case ExpressionsGroupsEnum.CONTACT:
      return <Trans id="editor-expression-group-title-contact">Extract contact property</Trans>;

    case ExpressionsGroupsEnum.MESSAGE:
      return <Trans id="editor-expression-group-title-message">Extract message property</Trans>;

    case ExpressionsGroupsEnum.COMMENT:
      return <Trans id="editor-expression-group-title-comment">Extract comment property</Trans>;

    case ExpressionsGroupsEnum.FACTORY:
      return <Trans id="editor-expression-group-title-factory">Use value</Trans>;

    case ExpressionsGroupsEnum.ENVIRONMENT:
      return <Trans id="editor-expression-group-title-environment">Environment</Trans>;

    case ExpressionsGroupsEnum.TRIGGERS:
      return <Trans id="editor-expression-group-title-triggers">Triggers</Trans>;

    case ExpressionsGroupsEnum.NETWORK:
      return <Trans id="editor-expression-group-title-network">Network</Trans>;

    case ExpressionsGroupsEnum.TABLE:
      return <Trans id="editor-expression-group-title-table">Rule table columns</Trans>;

    default:
      return id;
  }
};
